import { send } from '../../../../src/network';
import { type PaginatedDynamicConfigList } from '../../../../src/types/PaginatedDynamicConfigList';

export { type PaginatedDynamicConfigList };

export type Params<T extends readonly string[]> = {
  name: T;
  limit?: number;
  offset?: number;
};

export const DYNAMIC_CONFIGS_PATH = '/api/v2/dynamic_configs/';

export async function getDynamicConfigs<T extends readonly string[]>(
  params: Params<T>
) {
  const { name, limit, offset } = params;
  const query = new URLSearchParams();
  if (name.length > 1) {
    query.append('name__in', name.join(','));
  } else {
    query.append('name', name[0]);
  }

  if (limit !== undefined) {
    query.append('limit', limit.toString());
  }

  if (offset !== undefined) {
    query.append('offset', offset.toString());
  }

  return await send<PaginatedDynamicConfigList<T[number]>>({
    path: DYNAMIC_CONFIGS_PATH,
    query,
    method: 'GET',
  });
}
